import { useTranslation } from "react-i18next";

export default function FieldPageCrumb(): string {
  const { t } = useTranslation();
  return t("crumb.Dashboard");
}
